module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.25004",
      "conversations-internal-schema": "static-1.12163",
      "head-dlb": "static-1.4465",
      "hs-test-utils": "static-1.7446",
      "hubspot-url-utils": "static-1.3731",
      "HubStyleTokens": "static-2.10970",
      "I18n": "static-7.1477",
      "jasmine-runner": "static-1.5870",
      "quartz": "static-1.6281",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "webpack-env": "static-1.54",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.478",
      "visitor-ui-component-library": "static-1.5659",
      "enviro": "static-4.345",
      "hs-promise-rejection-tracking": "static-1.4918",
      "PortalIdParser": "static-2.319",
      "raven": "static-3.5386",
      "raven-hubspot": "static-1.5693",
      "bend-plugin-trellis-migration": "static-1.2993",
      "moment": "static-3.26",
      "cv-backend-services": "static-1.1383",
      "hub-http": "static-1.5499",
      "immutable": "static-2.19",
      "immutable-less": "static-1.4057",
      "quartz-config": "static-1.59",
      "quartz-core": "static-1.5500",
      "transmute": "static-2.77",
      "HeadJS": "static-2.641",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7008",
      "framer-motion": "static-1.57",
      "hs-test-utils-bend-plugin": "static-1.2557",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.139",
      "foundations-theming": "static-1.3857",
      "i18n-data": "static-1.211",
      "metrics-js": "static-1.9189",
      "moment-timezone": "static-5.72",
      "react-utils": "static-2.4892",
      "jasmine": "static-4.3774",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.44",
      "styled-components": "static-2.64",
      "UIComponents": "static-3.7917",
      "visitor-ui-component-library-icons": "static-1.5470",
      "bender-build-tools": "static-1.2637",
      "rpc-client-utils": "static-1.4153",
      "ts-schema": "static-1.3659",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.125",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-janus": "static-1.718",
      "hub-http-shared-msw-handlers": "static-1.8744",
      "hubspotter-http": "static-1.4125",
      "hubspotter-http-shared-msw-handlers": "static-1.8742",
      "icons": "static-2.599",
      "mobile-manifest-mixins": "static-1.414",
      "quick-fetch": "static-1.3482",
      "react-rhumb": "static-1.16145",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.335",
      "bend-plugin-foundations-components": "static-1.3277",
      "floating-ui": "static-1.45",
      "foundations-assets": "static-1.4319",
      "foundations-theming-specialty": "static-1.1573",
      "hs-story-utils": "static-1.8864",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.86",
      "tanstack-table": "static-1.23",
      "ui-images": "static-2.990",
      "bend-plugin-foundations-theming": "static-1.2340",
      "foundations-theming-base": "static-1.2842",
      "stylex": "static-1.21",
      "classnames": "static-2.10",
      "cssUtils": "static-1.628",
      "HubStyle": "static-2.11278",
      "sassPrefix": "static-1.145",
      "react-input-autosize": "static-2.17"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.25004",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12163",
      "head-dlb": "/head-dlb/static-1.4465",
      "hs-test-utils": "/hs-test-utils/static-1.7446",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3731",
      "HubStyleTokens": "/HubStyleTokens/static-2.10970",
      "I18n": "/I18n/static-7.1477",
      "jasmine-runner": "/jasmine-runner/static-1.5870",
      "quartz": "/quartz/static-1.6281",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.54",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.478",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5659",
      "enviro": "/enviro/static-4.345",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
      "PortalIdParser": "/PortalIdParser/static-2.319",
      "raven": "/raven/static-3.5386",
      "raven-hubspot": "/raven-hubspot/static-1.5693",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2993",
      "moment": "/moment/static-3.26",
      "cv-backend-services": "/cv-backend-services/static-1.1383",
      "hub-http": "/hub-http/static-1.5499",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.4057",
      "quartz-config": "/quartz-config/static-1.59",
      "quartz-core": "/quartz-core/static-1.5500",
      "transmute": "/transmute/static-2.77",
      "HeadJS": "/HeadJS/static-2.641",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7008",
      "framer-motion": "/framer-motion/static-1.57",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2557",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.139",
      "foundations-theming": "/foundations-theming/static-1.3857",
      "i18n-data": "/i18n-data/static-1.211",
      "metrics-js": "/metrics-js/static-1.9189",
      "moment-timezone": "/moment-timezone/static-5.72",
      "react-utils": "/react-utils/static-2.4892",
      "jasmine": "/jasmine/static-4.3774",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.44",
      "styled-components": "/styled-components/static-2.64",
      "UIComponents": "/UIComponents/static-3.7917",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5470",
      "bender-build-tools": "/bender-build-tools/static-1.2637",
      "rpc-client-utils": "/rpc-client-utils/static-1.4153",
      "ts-schema": "/ts-schema/static-1.3659",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.125",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-janus": "/hub-http-janus/static-1.718",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8744",
      "hubspotter-http": "/hubspotter-http/static-1.4125",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8742",
      "icons": "/icons/static-2.599",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.414",
      "quick-fetch": "/quick-fetch/static-1.3482",
      "react-rhumb": "/react-rhumb/static-1.16145",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.335",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3277",
      "floating-ui": "/floating-ui/static-1.45",
      "foundations-assets": "/foundations-assets/static-1.4319",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1573",
      "hs-story-utils": "/hs-story-utils/static-1.8864",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.86",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-images": "/ui-images/static-2.990",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2340",
      "foundations-theming-base": "/foundations-theming-base/static-1.2842",
      "stylex": "/stylex/static-1.21",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.628",
      "HubStyle": "/HubStyle/static-2.11278",
      "sassPrefix": "/sassPrefix/static-1.145",
      "react-input-autosize": "/react-input-autosize/static-2.17"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};